// extracted by css-extract-rspack-plugin
export default {"container":"container-ZK1Dd4","titleText":"titleText-loX77y","consentText":"consentText-RO18wE","consentTextError":"consentTextError-pPnbSk"};